import React from "react";
import Skeleton from "react-loading-skeleton";

function LoadingSkeleton() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
      <Skeleton className="LoadingSkeleton" width={1200} height={70} />
    </div>
  );
}

export default LoadingSkeleton;
